/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo } from 'react';
import Main from '../../../components/HOC/Main';
import { useDispatch, useSelector } from 'react-redux';
import { clearBannerData, deleteBanner, fetchBanner, selectBannerData, setBannerData, updateBanner } from '../../../store/slices/api/inner/bannerSlice';
import useApiRequest from '../../../store/slices/hook/useApiRequest';
import Button from '../../../components/common/Button';
import CustomTable from '../../../components/common/CustomTable';
import { selectSelectedBanner, setSelectedBanner, toggleBannerSlide, toggleCommonDeleteModal } from '../../../store/slices/common';
import BannerForm from '../../../components/pages/BannerForm';
import { FaPlus } from 'react-icons/fa';
import TableAction from '../../../components/TableAction';
import Switch from '../../../components/common/Switch';



export const BannerPage = () => {
  const dispatch = useDispatch();
  const bannerData = useSelector(selectBannerData);
  const selectedBanner = useSelector(selectSelectedBanner)

  const { handleSubmit: fetchData } = useApiRequest({
    apiAction: fetchBanner,
    setValueAction: setBannerData,
    clearValueActionOnError: clearBannerData,
    isForm: false,
    successMessage: false,
  });


  // delete start
  const openDeleteModal = (data) => {
    dispatch(setSelectedBanner(data))
    dispatch(toggleCommonDeleteModal())
  }
  const cancelDeleteModal = () => {
    dispatch(setSelectedBanner(null))
    dispatch(toggleCommonDeleteModal())
  }

  const afterAPICall = (res) => {
    fetchData()
    dispatch(setSelectedBanner(null))
    dispatch(toggleCommonDeleteModal())
  }

  const { handleSubmit: handleDelete } = useApiRequest({
    apiAction: deleteBanner,
    isForm: false,
    afterAPICall,
  });
  // delete end


  const handleEdit = (data) => {
    dispatch(setSelectedBanner(data));
    dispatch(toggleBannerSlide());
  }

  const handleAdd = () => {
    dispatch(setSelectedBanner(null));
    dispatch(toggleBannerSlide())
  }

  const afterUpdateApiCall = (res) => {
    fetchData()
  }

  const { handleSubmit: handleUpdate } = useApiRequest({
    apiAction: updateBanner,
    clearForm: false,
    isForm: false,
    successMessage: false,
    afterAPICall: afterUpdateApiCall,
  });

  const columns = useMemo(() => [
    {
      accessorKey: 'title',
      cell: info => info.getValue(),
      filterFn: 'includesStringSensitive',
    },
    {
      accessorKey: 'description',
      cell: info => info.getValue(),
      filterFn: 'includesStringSensitive',
    },
    {
      accessorKey: 'image',
      cell: info => <div className='h-20 w-28 flex items-center justify-center'>
        <img src={`${process.env.REACT_APP_BASE_URL}/assets/${info.getValue()}`} className='h-full w-auto rounded' alt='banner' />
      </div>,
    },
    {
      accessorKey: 'status',
      cell: info => <Switch onChange={() => { handleUpdate({ formData: { status: info.getValue() === 'active' ? 'inactive' : 'active'}, query: { bannerId: info.row.original.banner_id } }) }} checked={info.getValue() === 'active' ? true : false} />,
      filterFn: 'includesStringSensitive',
    },
    {
      id: 'actions',
      cell: info => <TableAction handleEditButton={() => { handleEdit(info?.row?.original) }} handleDeleteButton={() => { openDeleteModal(info?.row?.original) }} />,
      header: () => <span>Actions</span>,
    },
  ], [handleEdit, handleUpdate, openDeleteModal]);

  useEffect(() => {
    fetchData();
  }, [])

  return (
    <Main crumbs={[{ title: "masters" }, { title: "banners" }]} handleDelete={() => { handleDelete({ bannerId: selectedBanner.banner_id }) }} handleCandleDelete={cancelDeleteModal}>
      <CustomTable columns={columns} data={bannerData} tableTop={<Button onClick={handleAdd} size='small'><FaPlus /> Add banner</Button>} />
      <BannerForm defaultData={selectedBanner} fetchData={fetchData} />
    </Main>
  );
};
